import { CartProduct } from './../utils/Cart';
import { Cart } from "~/utils/Cart";
import { defineStore} from "pinia";
import type {User} from "~/utils/User";

const AUTH_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30

export type RequestData = {
    name:string,
    company_name:string,
    address:string,
    city:string,
    description:string,
    date_from: Date,
    date_to: Date,
    eventDays: number,
    telephone:string,
    email:string,
    subscribeNewsletter?:boolean
  }
export const useUserDataStorage = defineStore('userData', () => {
    const user = ref<User>()
    const browserCart = ref<Cart>()
    const requestData = ref<RequestData>({
          name: "",
          company_name:"",
          address:"",
          city:"",
          description: "",
          date_from: new Date(),
          date_to: new Date(),
          telephone: '',
          eventDays: 1,
          email: '',
      })

    const loggedIn = computed(()=>{
        return user.value?.token && user.value?.token != "";
    })
    return {user, loggedIn, browserCart,requestData}
},{
        persist: {
          async afterHydrate(context) {
            context.store.requestData.date_from = new Date(context.store.requestData.date_from)
            context.store.requestData.date_to = new Date(context.store.requestData.date_to)
          },
          storage: piniaPluginPersistedstate.cookies({
            maxAge: AUTH_COOKIE_MAX_AGE_SECONDS,
            sameSite: 'lax',
          }),
      }
})
